import React, { FC, useContext } from 'react';

import Tracking from 'component/User/Tracking';

import { AccommodationDataContext } from 'pages/hotels/context';

import Portal from 'utility/Bind/Portal/Portal';

import List from './__partials/List';

interface ListProps {
    target: string;
    isSemActive?: boolean;
    hasRecommender?: boolean;
}

export const AccommodationList: FC<ListProps> = ({
    target,
    isSemActive = false,
    hasRecommender = true,
}) => {
    const {
        view,
        accommodationList,
        alternativeHotelList,
        responseStatus,
        serviceInformation,
        lastClickedHotel,
        actionMap: { updateLastClickedHotel },
        tracking,
        transactionId,
    } = useContext(AccommodationDataContext);

    return (
        <Portal root={target}>
            <List
                view={view}
                accommodationList={accommodationList}
                alternativeHotelList={alternativeHotelList}
                responseStatus={responseStatus}
                serviceInformation={serviceInformation}
                lastClickedHotel={lastClickedHotel}
                updateLastClickedHotel={updateLastClickedHotel}
                tracking={tracking}
                transactionId={transactionId}
                isSemActive={isSemActive}
                hasRecommender={hasRecommender}
            />
            <Tracking tracking={tracking} />
        </Portal>
    );
};
